// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#x-ConfigEditor-configBtn {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}
`, "",{"version":3,"sources":["webpack://./modules/portal-core/editor/ConfigEditor.less"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;AAAF","sourcesContent":["\n#configBtn {\n  position: fixed;\n  top:0;\n  left:0;\n  z-index: 9999;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"configBtn": `x-ConfigEditor-configBtn`
};
export default ___CSS_LOADER_EXPORT___;
